module.exports = __webpack_public_path__ + "img/search_files.93288056.svg";